import { Button, Grid, Typography } from "@material-ui/core";
import React from "react";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { makeStyles, withStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  contentHeading: {
    whiteSpace: "pre-line",
    fontWeight: "bolder",
    color: theme.palette.ePrimary.base,
    margin: "0px 2% !important"
  },
  detailsSection: {
      overflow: "auto",
      whiteSpace: "pre-line",
      width:"90%",
      margin: "0px 2% !important",
      [theme.breakpoints.up("xs")]: {
        height: "25rem"
      },
      [theme.breakpoints.up("md")]: {
        height: "22rem"
      },
  },
  backButton: {
    color: theme.palette.ePrimary.base,
    [theme.breakpoints.down("xs")]: {
      margin: "2% !important"
    },
  },
}
));
export const CustomButton = withStyles((theme)=>(
  {
    root: {
      "& .MuiButton-startIcon": {
        marginRight: "0px"
      }
    }
  }
))(Button)
export default function EDetailedContent(props) {
  const classes = useStyles();
  let backClick = (e) => {
    props.toggleTab();
  };

  const detailedContentData = [
    {
      data: "We are a specialized engineering services organization that focuses on select industry segments to provide value added services and solutions",
    },
    {
      data: "Abjayon aims to help power, gas and water utilities transform themselves using digital technologies to meet current challenges as well as future opportunities. We leverage an ecosystem of partners and industry specialists to deliver sustainable and reliable technology services and experiences.",
    },
    {
      data: "Our digital transformation services helps utilities to digitise their processes, enhances operational efficiency.",
    },
    {
      data: "Our innovative products and enterprise applications help the energy companies to build digital relationships with their customers.",
    },
    {
      data: "We provide strategy and consulting services that help utility companies overcome challenges and stay on top of the changing trends.",
    },
    {
      data: "We help organizations reach higher levels of performance by providing onsite, remote and offsite support to their operations.",
    },
    {
      data: "We provide on-shore and off-shore staff augmentation services with dedicated resources specializing in various utilities functions and technologies.",
    },
    {
      data: "Our digital transformation services helps utilities to digitise their processes, enhances operational efficiency.",
    },
    {
      data: "Our software engineering services creates value for organizations by engineering innovative customer experiences, customizing products and technologies for new markets, integrating new-age technologies, facilitating faster time to market and ensuring a competitive edge.",
    },
    {
      data: "We complement our expertise as a solution vendor specializing in developing product & services designed to modernize the digital footprint of modern businesses and help guide them access potential funding & assistance from AWS to support their digital transformation journey including but not limited to - cloud migration services, cyber security and data management services.",
    },
    {
      data: "We enable security at the point of data, for both data at rest and data in transit. Help modern businesses leverage various cloud native security tools to build a comprehensive framework for enforcing compliance in cloud security practices & methodologies.",
    },
  ];

  return (
    <>
      <Grid container spacing={1} direction="column">
        <Grid item xs={12}>
          <CustomButton
            size="small"
            startIcon={<ArrowBackIosIcon fontSize="small" className="marginRight" />}
            onClick={backClick}
            align="left"
            className={classes.backButton}
          >
            <b>{props?.labelReady && props?.labels("E_LANDING_PAGE_BACK_BTN")}</b>
          </CustomButton>
        </Grid>

        <Grid item xs={12} >
          <Typography
            variant="h5"
            className={classes.contentHeading}
            dangerouslySetInnerHTML={{
              __html: props.title,
            }}
>
          </Typography>

        <div
          className={classes.detailsSection}
        >
          {detailedContentData.map((item) => (
              <Typography variant="subtitle2">{item.data}</Typography>
          ))}
        </div>
        </Grid>
      </Grid>
    </>
  );
}
